var emailAddressRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/i;
export function ensureValidGroupSmtpAddress(parameters) {
    if (!parameters.groupAlias || !parameters.groupDomain) {
        return null;
    }
    var groupSmtp = parameters.groupAlias + '@' + parameters.groupDomain;
    if (!isValidEmailAddress(groupSmtp)) {
        return null;
    }
    return groupSmtp;
}
function isValidEmailAddress(emailAddress) {
    // TODO: remove it from here when VSO:1041 is fixed
    return emailAddressRegex.test(emailAddress);
}
//# sourceMappingURL=mailGroupRouteSettings.js.map